module.exports = __webpack_public_path__ + "img/第6章_1-3_平行世界圖表1-1.jpg";